export default __webpack_public_path__ + "static/media/blur 2.21eff6a6.jpg";